import { collection, doc, getDocs, getDoc, setDoc, updateDoc, deleteDoc, writeBatch } from "firebase/firestore";
import { auth, db } from "./firebaseClient";

function taskCollection() {
  if (!auth?.currentUser || !db) throw new Error("يرجى تسجيل الدخول مجددًا.");
  return collection(db, "users", auth.currentUser.uid, "tasks");
}
async function result(operation) {
  try { return { data: await operation(), error: null }; }
  catch (error) { return { data: null, error }; }
}
export function listTasks() {
  return result(async () => {
    const snapshot = await getDocs(taskCollection());
    return snapshot.docs.map(item => ({ ...item.data(), id: item.id }))
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  });
}
export function createTask(row) {
  return result(async () => {
    const ref = doc(taskCollection());
    const data = { ...row, user_id: auth.currentUser.uid,
      source_local_id: ref.id, created_at: new Date().toISOString() };
    await setDoc(ref, data);
    return { ...data, id: ref.id };
  });
}
export function editTask(id, row) {
  return result(async () => {
    const ref = doc(taskCollection(), String(id));
    await updateDoc(ref, row);
    const snapshot = await getDoc(ref);
    return { ...snapshot.data(), id: snapshot.id };
  });
}
export function removeTask(id) {
  return result(() => deleteDoc(doc(taskCollection(), String(id))));
}
export function importTasks(rows) {
  return result(async () => {
    const target = taskCollection();
    const uid = auth.currentUser.uid;
    const existing = await getDocs(target);
    const ids = new Map();
    existing.docs.forEach(item => {
      if (item.data().source_local_id) ids.set(String(item.data().source_local_id), item.id);
      ids.set(item.id, item.id);
    });
    // Stable document IDs make retries safe even after a partially completed import.
    const writes = new Map();
    for (const row of rows) {
      const source = String(row.source_local_id);
      const bytes = new TextEncoder().encode(source);
      const digest = await window.crypto.subtle.digest("SHA-256", bytes);
      const hash = Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, "0")).join("");
      const id = ids.get(source) || `import_${hash}`;
      ids.set(source, id);
      writes.set(id, { ...row, user_id: uid });
    }
    const entries = [...writes.entries()];
    let committed = 0;
    try {
      for (let start = 0; start < entries.length; start += 400) {
        const batch = writeBatch(db);
        const chunk = entries.slice(start, start + 400);
        chunk.forEach(([id, row]) => batch.set(doc(target, id), row, { merge: true }));
        await batch.commit();
        committed += chunk.length;
      }
    } catch (error) {
      throw new Error(`تم حفظ ${committed} سجل قبل توقف الاستيراد. يمكن إعادة استيراد الملف بأمان. ${error.message}`);
    }
    return committed;
  });
}
